function ErrorMessage({ message }) {
  if (!message) return null;
  return (
    <div className="d-block w-100 mt-1 text-xs text-red-500">{message}</div>
  );
}

export default ErrorMessage;
